export default __webpack_public_path__ + "static/media/Harness of Tribulation.e3b0373c.jpg";